export default {
  setNotifications(state, payload) {
    state.notifications = payload;
  },
  addNotification(state, payload) {
    state.notifications = [payload, ...state.notifications];
  },
  setUnreadNotifCount(state, payload) {
    state.unreadNotifCount = payload;
  },
};
